import { noChange } from 'lit';
import { AsyncDirective } from 'lit/async-directive.js';
import {
  directive,
  type ElementPart,
  type PartInfo,
  PartType,
} from 'lit/directive.js';

import { bindStreamLainDisclosure } from './streamlain-disclosure-controller';

/** Bind only after Lit has committed the summary/body; release with the owning part. */
class StreamLainDisclosureDirective extends AsyncDirective {
  private element?: HTMLDetailsElement;
  private release?: () => void;
  private revision = 0;

  constructor(part: PartInfo) {
    super(part);
    if (part.type !== PartType.ELEMENT) {
      throw new Error('Disclosure motion requires an element part');
    }
  }

  render() {
    return noChange;
  }

  override update(part: ElementPart) {
    if (!(part.element instanceof HTMLDetailsElement)) {
      throw new Error('Disclosure motion requires a details element');
    }
    if (this.element !== part.element) {
      this.disconnected();
      this.element = part.element;
    }
    if (!this.release) this.connect();
    return noChange;
  }

  private connect() {
    const revision = ++this.revision;
    queueMicrotask(() => {
      if (this.isConnected && revision === this.revision && this.element) {
        this.release = bindStreamLainDisclosure(this.element);
      }
    });
  }

  protected override disconnected() {
    this.revision++;
    this.release?.();
    this.release = undefined;
  }

  protected override reconnected() {
    this.connect();
  }
}

export const streamLainDisclosureMotion = directive(
  StreamLainDisclosureDirective
);
